export default {
  SET_CONTACTS_TABLE_LIST(state, data) {
    state.contacts = data
  },
  SET_CONTACTS_TABLE_LIST2(state, data) {
    state.contacts2 = data
  },
  SET_ALL_CONTACTS(state, data) {
    state.allContacts = data
  },
  SET_ALL_CONTACT_CONTRACTS(state, data) {
    state.allContactContracts = data
  },
  SET_CONTACTS_AGENT(state, data) {
    state.allagents = data
  },
  SET_CONTACTS_LIST(state, data) {
    state.contactsCard = {
      count: data.count,
      next: data.next,
      results: [
        ...state.contactsCard.results,
        ...data.results,
      ],
    }
  },

  SET_ALL_REPORT_LIST(state, data) {
    state.reportList = data
  },

  SET_ONE_REPORT(state, data) {
    state.reportOne = data
  },
  
  
  SET_TAB_PROVIDER_OR_BUYER(state, data) {
    state.tabProvidersOrBuyers = data
  },
}
